import altusTopLogo from 'assets/welcome/altus_top_logo.svg';
import check from 'assets/welcome/check.svg';
import Button from 'components/button/button';
import { useMemo } from 'react';
import styles from './welcome-view.module.scss';

/* eslint-disable-next-line */
export interface WelcomeViewProps {}

export function WelcomeView(props: WelcomeViewProps) {
  const args = useMemo(() => ['Plages de déconnexion', 'Limitez les applications', 'Localisez votre enfant'], []);

  return (
    <div className={styles.welcome}>
      <div className={styles.top}>
        <div className={styles.logoWrapper}>
          <img src={altusTopLogo} alt="Logo" className={styles.logo} />
        </div>
        <div className={styles.title}>
          Contrôle parental
          <br />
          <span className={styles.orange}>100% gratuit</span>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.arguments}>
          {args.map((argument, index) => (
            <div key={index} className={styles.argument}>
              <img src={check} alt="Check" className={styles.check} />
              {argument}
            </div>
          ))}
        </div>
        <Button href="/onboarding/choice/device">C&apos;EST PARTI !</Button>
      </div>
    </div>
  );
}

export default WelcomeView;
